import React from 'react'
import { Provider } from 'react-redux'

import configureStore from './configureStore'
import App from './containers/App'
import { initialState as initialAppState } from './reducer/app'
import { WtaiUploadWidgetProps, EASYBIB } from './types'
import { HEADING, SUBHEADING } from './standalone/defaults'

export const ERROR_ONE_PROP_REQUIRED =
  "Only one of props 'onUploadSuccess: func' or 'editorBaseUrl: string' must be defined."
// eslint-disable-next-line max-len
export const ERROR_TWO_PROP_REQUIRED =
  'If you need a hard redirect, pass `editorBaseUrl`, if you want a custom transition pass `onUploadSuccess`.'

const defaultProps: Pick<WtaiUploadWidgetProps, 'site' | 'headingText' | 'subheadingText'> = {
  site: EASYBIB,
  headingText: HEADING,
  subheadingText: SUBHEADING,
}

const Dropin: React.FunctionComponent<WtaiUploadWidgetProps> = props => {
  const {
    headingText,
    subheadingText,
    onUploadSuccess,
    editorBaseUrl,
    authApiUrl,
    onAuthUpdate,
    site,
    wtaiUploadUrl,
    wtaiExpressUrl,
    initFreshToken,
    pasteOnly,
    alignText,
    initRSW,
  } = props

  if (!(props.onUploadSuccess || props.editorBaseUrl)) {
    throw new Error(`${ERROR_ONE_PROP_REQUIRED} Neither prop is defined.\n${ERROR_TWO_PROP_REQUIRED}`)
  } else if (props.onUploadSuccess && props.editorBaseUrl) {
    const msg = `${ERROR_ONE_PROP_REQUIRED} Both props are defined.\n${ERROR_TWO_PROP_REQUIRED}`
    throw new Error(msg)
  }

  const store = configureStore({
    editorBaseUrl,
    onUploadSuccess,
    authApiUrl,
    onAuthUpdate,
    site,
    wtaiUploadUrl,
    wtaiExpressUrl,
    app: {
      ...initialAppState,
      pasteOnly,
      initRSW,
      initFreshToken,
    },
  })

  const appProps = {
    headingText,
    subheadingText,
    site,
    pasteOnly,
    alignText,
  }

  return (
    <Provider store={store}>
      <App {...appProps} />
    </Provider>
  )
}
Dropin.defaultProps = defaultProps
export default Dropin
